module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/Clipboard-list-ad6963b38c0d6595a93fbda65f9c033b.svg";